import { resourceReducer } from 'redux-resource';

const csa = resourceReducer('csa');
export default csa;

export const getLastCsa = (state) => {
  if (!state.requests.search || state.requests.search.status !== 'SUCCEEDED') {
    return false;
  }
  const id = state.requests.search.ids;
  return state.resources[id[0]];
};
